import { getEnvironmentVariables, Environment } from '~/environment';

export const useEnvironmentVariables = (): Environment => {
  return getEnvironmentVariables();
};
